import { observer } from "mobx-react-lite";
import { Sheet, SheetContent } from "../components/ui/sheet";
import { useStore } from "@/hooks/useStore";
import { cn } from "@/lib/utils";
import { sheetRegistry } from "@/config/sheetRegistry";

const DEFAULT_SHEET_WIDTH = "max-w-[520px]";
const SHEET_WIDTH: Partial<Record<keyof typeof sheetRegistry, string>> = {
	alarmDetail: "max-w-[600px]",
};

export const SideSheet = observer(() => {
	const {
		uiStore: { sheetStore },
	} = useStore();
	const { type, props } = sheetStore;

	if (!type) return null;

	const Component = sheetRegistry[type as keyof typeof sheetRegistry];
	if (Component) {
		const widthClass = SHEET_WIDTH[type as keyof typeof sheetRegistry] ?? DEFAULT_SHEET_WIDTH;
		return (
			<Sheet
				open
				onOpenChange={open => {
					if (!open) sheetStore.close();
				}}
			>
				<SheetContent className={cn("flex flex-col w-full p-0", widthClass)}>
					<Component {...(props as any)} />
				</SheetContent>
			</Sheet>
		);
	}
});
